import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetSoldFoodAndDrinkItemRecords } from '@shared/api/hooks/sold-goods/food-and-drink';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import SoldFoodAndDrinkItemSalesTable from '../components/item/sold-food-and-drink-item-sales-table';
import { useSoldFoodAndDrinkItem } from '../sold-food-and-drink-item-context';

export default function SoldFoodAndDrinkItemSalesPage() {
  const { item } = useSoldFoodAndDrinkItem();

  const [companyReports] = useQueryState(
    'companyReport',
    parseAsArrayOf(parseAsString)
  );

  const { page, perPage, period, site, sort } = useDataTableQueryState({
    filters: ['supplier', 'period', 'site'],
  });

  const {
    data,
    status,
    isLoading,
    isFetching,
    isPreviousData,
    isFetchedAfterMount,
  } = useGetSoldFoodAndDrinkItemRecords({
    activityUuid: item.uuid,
    params: {
      page_size: perPage,
      company_reports: companyReports || undefined,
      page,
      sites: site || undefined,
      time_periods: period || undefined,
      sort: formatMultipleSortingForEndpoint(sort! || []),
    },
  });

  return (
    <Page name={`${item.soldGood.name} Sales`} page="subpage">
      <SoldFoodAndDrinkItemSalesTable
        data={data!}
        status={status}
        isLoading={isLoading}
        isFetching={isFetching}
        isPreviousData={isPreviousData}
        isFetchedAfterMount={isFetchedAfterMount}
      />
    </Page>
  );
}
